
export const Testimonials = (props) => {
  return (
    <div id='testimonials'>
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3932.1928547846605!2d-36.661945684631306!3d-9.749725706078902!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x705d5996f0a1dc5%3A0x9297846ab6686041!2sPra%C3%A7a%20Manoel%20Andr%C3%A9%2C%20296%20-%20Centro%2C%20Arapiraca%20-%20AL%2C%2057300-005!5e0!3m2!1spt-BR!2sbr!4v1626876226833!5m2!1spt-BR!2sbr" width="100%" height="500"  allowfullscreen="" loading="lazy"></iframe>
    </div>
  )
}
